import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { ButtonDestructive, ButtonTertiary } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"
import { FunctionComponent } from "react"

interface DeleteTagModalProps {
    onSubmit: () => void
    onCancel: () => void
}

export const DeleteTagModal: FunctionComponent<DeleteTagModalProps> = ({ onSubmit, onCancel }) => (
    <HighPriorityNovaModalContainer
        className="max-w-lg w-full"
        title="Delete Tag?"
        closeModal={onCancel}
        bottomBar={
            <div className="flex justify-end gap-2 w-full">
                <ButtonTertiary title="Cancel" onClick={onCancel} />
                <ButtonDestructive title="Delete Tag" LeftIcon={Icons.Trash} onClick={onSubmit} />
            </div>
        }
    >
        <div className="flex flex-col gap-4 pt-2 items-center">
            <h4 className="text-gray-0">
                This will remove the tag everywhere {"it's"} been applied.
            </h4>
        </div>
    </HighPriorityNovaModalContainer>
)
